import request from '@/utils/request'

export function updateChestCfg(data) {
  return request({
    url: 'api/v1/chest-skin/updateCfg',
    method: 'post',
    data: data
  })
}

export function getChestCfgList(data) {
  return request({
    url: 'api/v1/chest-skin/getCfg',
    method: 'post',
    data: data
  })
}

export function getChestWeight(data) {
  return request({
    url: 'api/v1/chest-skin/getChestWeightCfg',
    method: 'post',
    data: data
  })
}

export function exportChestWeight(data) {
  return request({
    url: 'api/v1/chest-skin/exportChestWeightCfg',
    method: 'post',
    data: data
  })
}
export function importChestWeight(data) {
  return request({
    url: 'api/v1/chest-skin/importChestWeightCfg',
    method: 'post',
    data: data
  })
}

export function getChestCfgAll() {
  return request({
    url: 'api/v1/chest-skin/getAllCfg',
    method: 'post'
  })
}

